<template>
  <label
    class="date-picker"
    :class="selector">
    <span class="date-picker__label">{{ label }}</span>
    <div
      v-if="prefix"
      class="date-picker__prefix">
      {{ prefix }}
    </div>
    <DatePicker v-bind="$attrs"
                :value="value"
                :format="$attrs.format || 'DD.MM.YYYY'"
                input-class="date-picker__input"
                popup-class="date-picker__popup"
                :lang="lang"
                @input="onInput"
                class="date-picker__picker">
      <!--    <template v-slot:input="a">-->
      <!--      <BaseInput :value="value"-->
      <!--                 type="text"-->
      <!--                 class="date-picker__input"/>-->
      <!--    </template>-->
      <template v-slot:icon-calendar>
        <span class="date-picker__ico-calendar">
          <BaseSvg name="ico-calendar"/>
        </span>
      </template>
      <template v-slot:icon-clear>
        <span class="date-picker__ico-close">
          <BaseSvg name="ico-close"/>
        </span>
      </template>
    </DatePicker>
    <InputError :value="error"/>
  </label>
</template>

<script>
  import InputError from './BaseInputError'
  import datePickerMixin from '@/mixins/datePickerMixin'

  export default {
    mixins: [datePickerMixin],
    components: {
      InputError,
    },
    props: {
      value: [String, Date, Array],
      prefix: String,
      label: String,
      error: [String, Array],
    },
    data() {
      return {}
    },
    computed: {
      computedValue() {
        return new Date()
      },
      selector() {
        return {
          '_error': this.error,
          '_label-top': this.label,
        }
      },
    },
    methods: {
      onInput(value) {
        this.$emit('input', value)
      },
    }
  }
</script>

<style lang="less">
  .mx-datepicker {
    width: auto;
  }
</style>
